import { render, staticRenderFns } from "./Directories.vue?vue&type=template&id=9915f1f0&scoped=true&"
import script from "./Directories.vue?vue&type=script&lang=js&"
export * from "./Directories.vue?vue&type=script&lang=js&"
import style0 from "./Directories.vue?vue&type=style&index=0&id=9915f1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915f1f0",
  null
  
)

export default component.exports